import { BaseModel } from "model/BaseModel";
import ItemPlanoInspecao from "./ItemPlanoInspecao";

export default class PlanoInspecao implements BaseModel{
    id: number;
    codigo: string = "";
    codigoInterno: string;
    nome: string;
    descricao: string;
    fase: string;
    itens: ItemPlanoInspecao[];

    constructor(
        id: number = 0,
        codigoInterno: string = "",
        nome: string = "",
        descricao: string = "",
        fase: string = "",
        itens: ItemPlanoInspecao[] = []
    ) {
        this.id = id;
        this.codigoInterno = codigoInterno;
        this.nome = nome;
        this.descricao = descricao;
        this.fase = fase;
        this.itens = itens;
    }
}